<template>
  <div class="gardeType">
    <Breadcrumb></Breadcrumb>
    <div class="title">请选择如何上传成绩单</div>
    <ul>
      <li>
        <div class="title_box" @click="selectType(1)">
          <p>登录查询 <img src="@/assets/login.svg" alt=""></p>
        </div>
        <div class="describe">教师录入的时候需要绑定系统的字段，并且学生需要登录平台账号查询自己的成绩，并有成长分析功能</div>
      </li>
      <li>
        <div class="title_box" @click="selectType(2)">
          <p>无需登录查询<img style="margin-top:46px;" src="@/assets/noLogin.svg" alt=""></p>
        </div>
        <div class="describe">教师无需与系统绑定任何字段，学生不用登录平台也可查询自己的成绩，没有成长分析功能</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Breadcrumb } from "@/components";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    getText() {},
  },
  methods: {
    selectType(type){
      this.$router.push({path:'/uploadGrade',query:{type:type}})
    }
  },
};
</script>

<style lang="less" scoped>
.gardeType {
  background: #ffffff;
  padding: 0 14Px;
  min-height: 1000Px;
  .title{
    text-align: center;
    font-size: 18Px;
    color: #191919;
    margin: 52Px 0 81Px;
    font-weight: bold;
  }
  ul{
    padding: 0 72Px;
    display: flex;
    justify-content: space-between;
    li{
      width: 272Px;
      font-size: 14Px;
      color: #444;
      .title_box{
        height: 317Px;
        text-align: center;
        font-size: 18Px;
        color: #191919;
        border-radius: 8Px;
        box-shadow: 1Px 3Px 10Px 0Px rgba(145, 144, 144, 0.5);
        overflow: hidden;
        margin-bottom: 47Px;
        p{
          margin-top: 48Px;
        }
        img{
          display: block;
          margin: 60Px auto 0;
        }
      }
    }
  }
}
</style>
